export default "__VITE_ASSET__C1qsJB5O__"